import { Injectable } from '@angular/core';
import { Notification } from './notification';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  constructor() {
    const storedAlerts = localStorage.getItem('alertsChecked');
    if (storedAlerts) {
      this.newAlertsCheckedAt = new Date(JSON.parse(storedAlerts));
    }
    setInterval(() => {
      if (new Date().getTime() - this.lastRefresh.getTime() > 65000) {
        this.setNotifications(this.notifications$.getValue());
      }
    }, 70000);
  }

  private newAlertsCheckedAt = new Date(0);
  private lastRefresh = new Date();
  private notifications$ = new BehaviorSubject<Notification[]>([]);
  private newNotifications$ = new BehaviorSubject<number | null>(null);

  public checkAlerts() {
    this.newAlertsCheckedAt = new Date();
    localStorage.setItem(
      'alertsChecked',
      JSON.stringify(this.newAlertsCheckedAt)
    );
    this.refreshCheckedAlerts(this.notifications$.getValue());
  }
  public getNotifications(): Observable<Notification[]> {
    return this.notifications$.asObservable();
  }

  public getNewNotifications(): Observable<number | null> {
    return this.newNotifications$.asObservable();
  }

  public reset() {
    this.notifications$.next([]);
  }

  setNotifications(notifications: Notification[]) {
    this.lastRefresh = new Date();
    const oldNotifications = this.notifications$.getValue();
    const newNotifications = notifications.filter(
      (n) => !oldNotifications.some((old) => old.id === n.id)
    );
    oldNotifications.forEach((on) => (on.isNew = false));
    oldNotifications.push(...newNotifications);
    const now = new Date();
    // currently only display last 24 hours notifications.. later allow more control on this.
    const next = oldNotifications.filter(
      (n) =>
        Math.floor(Math.abs(now.getTime() - n.time.getTime()) / 3600000) <= 24
    );

    this.refreshAlertsTimeText(next);
    this.refreshCheckedAlerts(next);
    next.sort((a, b) => (a.time.getTime() > b.time.getTime() ? -1 : 1));
    this.notifications$.next(next);
  }

  refreshAlertsTimeText(alerts: Notification[]) {
    alerts.forEach((a) => (a.timeText = this.getTimeDifferenceText(a.time)));
  }

  private getTimeDifferenceText(time: Date) {
    const now = new Date();
    const hours = Math.floor(
      Math.abs(now.getTime() - time.getTime()) / 3600000
    );
    if (hours > 1) {
      return `${hours} ${$localize`hours ago`}.`;
    }
    if (hours === 1) {
      return $localize`one hour ago`;
    }

    const minutes = Math.floor(
      Math.abs(now.getTime() - time.getTime()) / 60000
    );
    if (minutes > 1) {
      return `${minutes} ${$localize`minutes ago`}.`;
    }
    if (minutes === 1) {
      return $localize`one minute ago`;
    }
    return $localize`just now`;
  }

  refreshCheckedAlerts(alerts: Notification[]) {
    if (this.newAlertsCheckedAt && !isNaN(this.newAlertsCheckedAt.getTime())) {
      alerts.forEach((n) => (n.isRead = n.time <= this.newAlertsCheckedAt));
    }

    const newCount = alerts.reduce(
      (total, notification) => total + (!notification.isRead ? 1 : 0),
      0
    );
    if (newCount > 0) {
      this.newNotifications$.next(newCount);
    } else {
      this.newNotifications$.next(null);
    }
  }
}
